import React from 'react';

import { IMSARMBTSReport } from '../../../../types/services.interfaces/mbts-ux';

import { ConsentLock } from '../ConsentLock';

import { SectionTooltip } from './SectionTooltip';
import { SECTION_IDS, getRubricLevel } from './utils';

interface AuditMatrixProps {
    report: IMSARMBTSReport;
    isConsentLocked: boolean;
    openConsentDataGather: () => void;
};

export const AuditMatrix = (props: AuditMatrixProps) => {
    const { report, isConsentLocked, openConsentDataGather } = props;

    return (
        <section id={SECTION_IDS.audit} className="mbts_analysis_v2__section mbts_analysis_v2__audit">
            <ConsentLock isConsentLocked={isConsentLocked} openConsentDataGather={openConsentDataGather} />

            <div className="mbts_analysis_v2__section__head">
                <div>
                    <h3 className="mbts_analysis_v2__section__title">Performance Matrix: Deep-Dive Rubric Audit</h3>
                    <p className="mbts_analysis_v2__section__subtitle">
                        Complete breakdown of performance levels and recommendations across parameters.
                    </p>
                </div>
            </div>

            <div className="mbts_analysis_v2__audit__table_wrap">
                <table className="mbts_analysis_v2__audit__table">
                    <thead>
                        <tr>
                            <th>Rubric Parameter</th>
                            <th>Level Status</th>
                            <th>Specific Recommendation & Guidance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {report.rubric_parameters.map(parameter => {
                            const level = getRubricLevel(parameter.score);

                            return (
                                <tr key={parameter.testing_skill.title}>
                                    <td>
                                        <div className="mbts_analysis_v2__audit__param">
                                            <strong>{parameter.testing_skill.title}</strong>
                                            <SectionTooltip content={parameter.testing_skill.tooltip_content ?? ''} />
                                        </div>
                                    </td>
                                    <td>
                                        <span className={`mbts_analysis_v2__audit__level mbts_analysis_v2__audit__level--${level.level}`}>
                                            {level.title}
                                        </span>
                                    </td>
                                    <td>{parameter.recommendation}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="mbts_analysis_v2__audit__cards">
                {report.rubric_parameters.map(parameter => {
                    const level = getRubricLevel(parameter.score);

                    return (
                        <div key={parameter.testing_skill.title} className="mbts_analysis_v2__audit__card">
                            <div className="mbts_analysis_v2__audit__card__head">
                                <div className="mbts_analysis_v2__audit__param">
                                    <strong>{parameter.testing_skill.title}</strong>
                                    <SectionTooltip content={parameter.testing_skill.tooltip_content ?? ''} />
                                </div>
                                <span className={`mbts_analysis_v2__audit__level mbts_analysis_v2__audit__level--${level.level}`}>
                                    {level.title}
                                </span>
                            </div>
                            <p className="mbts_analysis_v2__audit__card__label">Recommendations</p>
                            <p>{parameter.recommendation}</p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};
